import gql from 'graphql-tag';

export default gql`
  mutation EditProduction(
    $id: ID!
    $name: String
    $publish: Boolean
    $description: String
    $type: String
    $year: Int
    $rights: String
    $budget: String
    $saleOrRent: String
    $sets: String
    $theaterId: ID
    $costumes: String
    $titles: String
    $props: String
    $orchestration: String
    $isDigital: Boolean
    $recordtype: String
    $numberofcameras: String
    $soundtype: String
    $royaltylength: String
    $features: [ProductionFeatureInput]
    $images: [ProductionImageInput]
  ) {
    editProduction(
      id: $id
      publish: $publish
      name: $name
      theaterId: $theaterId
      description: $description
      type: $type
      year: $year
      rights: $rights
      budget: $budget
      saleOrRent: $saleOrRent
      sets: $sets
      titles: $titles
      costumes: $costumes
      props: $props
      orchestration: $orchestration
      features: $features
      images: $images
      isDigital: $isDigital
      recordtype: $recordtype
      numberofcameras: $numberofcameras
      soundtype: $soundtype
      royaltylength: $royaltylength
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/EditProduction.js